import script from "./AdvancedTextAreaField.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdvancedTextAreaField.vue?vue&type=script&lang=ts&setup=true"

import "./AdvancedTextAreaField.vue?vue&type=style&index=0&id=351a2695&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351a2695"]])

export default __exports__